/** Равенство по содержимому через `JSON.stringify`: хватает для данных, пришедших из JSON
 *  (без функций, `Date` и циклов). Порядок ключей значим — сравнивать стоит значения одного
 *  источника (форма и её засев, черновик и его основа). */
export const sameJson = (a: unknown, b: unknown): boolean => JSON.stringify(a) === JSON.stringify(b)
